module.exports = __webpack_public_path__ + "img/login.4334bf95.svg";